setTimeout(function() {
    $.validator.addMethod("phoneNumber", function( value, element ) {
        var regex = new RegExp("^[0-9 ()+-]+$");
        var key = value;
    
        if (!regex.test(key)) {
           return false;
        }
        return true;
    }, "Please use only digits and +- characters");
    
    $.validator.addMethod("customemail", 
        function(value, element) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(value);
        }, 
        "Please enter correct email address"
    );
}, 1000);


const lang = $('html').attr('lang');
// https://github.com/jquery-validation/jquery-validation/tree/master/src/localization
if (lang == 'pl-PL') {
    $.extend( $.validator.messages, {
        required: "To pole jest wymagane.",
        remote: "Proszę o wypełnienie tego pola.",
        email: "Proszę o podanie prawidłowego adresu email.",
        customemail: "Proszę o podanie prawidłowego adresu email.",
        url: "Proszę o podanie prawidłowego URL.",
        date: "Proszę o podanie prawidłowej daty.",
        dateISO: "Proszę o podanie prawidłowej daty (ISO).",
        number: "Proszę o podanie prawidłowej liczby.",
        digits: "Proszę o podanie samych cyfr.",
        creditcard: "Proszę o podanie prawidłowej karty kredytowej.",
        equalTo: "Proszę o podanie tej samej wartości ponownie.",
        extension: "Proszę o podanie wartości z prawidłowym rozszerzeniem.",
        nipPL: "Proszę o podanie prawidłowego numeru NIP.",
        phonePL: "Proszę o podanie prawidłowego numeru telefonu",
        maxlength: $.validator.format( "Proszę o podanie nie więcej niż {0} znaków." ),
        minlength: $.validator.format( "Proszę o podanie przynajmniej {0} znaków." ),
        rangelength: $.validator.format( "Proszę o podanie wartości o długości od {0} do {1} znaków." ),
        range: $.validator.format( "Proszę o podanie wartości z przedziału od {0} do {1}." ),
        max: $.validator.format( "Proszę o podanie wartości mniejszej bądź równej {0}." ),
        min: $.validator.format( "Proszę o podanie wartości większej bądź równej {0}." ),
        pattern: $.validator.format( "Pole zawiera niedozwolone znaki." ),
        phoneNumber: "Numer telefonu może zawierać tylko cyfry oraz znaki +-"
    } );
} else if (lang == 'he-IL') {
    $.extend( $.validator.messages, {
        required: "השדה הזה הינו שדה חובה",
        remote: "נא לתקן שדה זה",
        email: "נא למלא כתובת דוא\"ל חוקית",
        customemail: "נא למלא כתובת דוא\"ל חוקית",
        url: "נא למלא כתובת אינטרנט חוקית",
        date: "נא למלא תאריך חוקי",
        dateISO: "נא למלא תאריך חוקי (ISO)",
        number: "נא למלא מספר",
        digits: "נא למלא רק מספרים",
        creditcard: "נא למלא מספר כרטיס אשראי חוקי",
        equalTo: "נא למלא את אותו ערך שוב",
        extension: "נא למלא ערך עם סיומת חוקית",
        maxlength: $.validator.format( ".נא לא למלא יותר מ- {0} תווים" ),
        minlength: $.validator.format( "נא למלא לפחות {0} תווים" ),
        rangelength: $.validator.format( "נא למלא ערך בין {0} ל- {1} תווים" ),
        range: $.validator.format( "נא למלא ערך בין {0} ל- {1}" ),
        max: $.validator.format( "נא למלא ערך קטן או שווה ל- {0}" ),
        min: $.validator.format( "נא למלא ערך גדול או שווה ל- {0}" )
    } );
}


class EventRegistration {
    constructor() {
        this.init();
    }

    init() {
        let self = this;

        this.form = $('.js-eventreg');
        this.ui = {
            available: $('.js-remamnt'),
            msgsContainer: this.form.find('.formResult'),
            msgs: this.form.find('.formResult > div'),
            popup: $('.articlePopup'),
            popupBlend: $('.articlePopup__blend')
        }

        this.loading = false;

        this.form.validate({
            ignore: ".ignore",
            rules: {
                'phone': {phoneNumber: true, required: true},
                'agree': 'required',
                'email': {
                    required: true,
                    customemail: true
                },
                'hiddenRecaptcha': {
                    required: function () {
                        if (grecaptcha.getResponse() == '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            errorClass: 'js-input-error-state',
            errorElement: 'div',
            errorPlacement: function(error, element) {
                element.parent().append(error);
            },
            invalidHandler: function(form, validator) {
                if (!validator.numberOfInvalids()) return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - 125
                }, 1000);
            },
            submitHandler: function(form) {
                self.submitHandler();
                return false;
            }
        });

        $('.js-popup-eventreg').on('click', function(e) {
            e.preventDefault();

            $(this).blur();
            $('body').addClass('is-popupopen');
        });

        self.ui.popupBlend.on('click', self.closePopup.bind(self));
        $('.articlePopup__close').on('click', self.closePopup.bind(self));
    }

    closePopup(e) {
        e.preventDefault();
        $('body').removeClass('is-popupopen');
        console.log(this);
        this.resetForm();
    }

    submitHandler() {
        // e.preventDefault();
        const self = this;

        if (self.loading) return;
        self.setLoading(true);

        let captcha = '';
        if (typeof grecaptcha == 'object') {
            captcha = grecaptcha.getResponse();
        }

        $.ajax({
            url: window.ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                action: 'event_registration',
                data: self.form.serialize(),
                captcha: captcha
            },
            success: function(response) {
                self.success(response);
            },
            error: function(response) {
                console.log(response);
                self.setLoading(false);
            }
        });
    }

    setLoading(to) {
        if (to == true) {
            this.form.addClass('loading');
            this.loading = true;
        }
        if (to == false) {
            this.form.removeClass('loading');
            this.loading = false;
        }
    }

    success(result) {
        const self = this;
        this.setLoading(false);

        this.ui.msgs.hide();
        console.log(result.state.available);

        this.ui.msgsContainer.find('div.formResult__' + result.status).show();
        
        if (result.status == 'ok') {
            this.form.get(0).reset();
            this.form.find('.forms__field').hide();
        }

        if (result.state) {
            this.ui.available.html(result.state.available);
            this.form.find('input[name="count"]').prop('max', parseInt(result.state.available));
        }

        if (result.status == 'notavailable') {
            this.form.find('input[name="count"]').val(parseInt(result.state.available));
        }

        // $('body, html').stop().animate({
        //     scrollTop: self.ui.popup.offset().top + 10
        // });
    }

    resetForm() {
        this.ui.msgs.hide();
        this.form.get(0).reset();
        this.form.find('.forms__field').show();
    }
};

$('document').ready(function() {
    if ($('body').hasClass('single-events')) {
        new EventRegistration();
    }
});